import React from 'react'
import { isNil } from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withState, withHandlers, lifecycle, withProps } from 'recompose'
import { FormattedMessage } from 'react-intl'

import Overlay from '../components/Overlay'

import Hide from './../components/Hide'
import FileLogo from '../components/Icons/File'
import Textarea from 'react-textarea-autosize'

import GiftCardsBuy from './GiftCardsBuy'
import CheckCardForm from './../components/GiftCardsCheck'

import { fetchingState } from './../helpers/hocs.js'
import { get as getFeedback, send as sendFeedback } from '../store/reducers/feedback'
import Loader from './../components/Loader'
import { getLoggedUser } from '../selectors/user.js'

const GiftCardsPage = ({ /*data,*/ fetching, formOpened, setFormState, submit, data, tmpData, setData, setInput, success = null,info, setSuccess,
  showCheckCard, setShowCheckCard, isLogged, setIsLogged, user }) => {

  const questionsArr = [{id: '1', title: 'Что такое электронный подарочный сертификат?',
  text: 'Электронный подарочный сертификат Meet For Charity - это неперсонифицированный электронный документ с номиналом, сроком действия, уникальным номером и пин-кодом. Покупка сертификата доступна только после входа в аккаунт. После оплаты сертификат сразу отправляется на email, указанный при оформлении.'},
  {id: '2', title: 'Какие основные условия пользования подарочным сертификатом?', text: 'Номинал подарочного сертификата может быть любым от 3 000 руб до 500 000 руб. Срок действия сертификата - 1 год с момента внесения денежных средств. Подарочный сертификат может быть использован многократно в пределах размера его номинала и срока действия.'},
  {id: '3', title: 'Мне подарили сертификат, как им воспользоваться?', text: 'Все просто! Вы можете использовать подарочный сертификат на аукционах Meet for Charity и в разделе Charity Shop. Для этого в форме оплаты необходимо выбрать пункт "Подарочный сертификат", ввести его номер и пин-код и нажать "Использовать".'},
  {id: '4', title: 'Когда происходит списание средств с подарочного сертификата?', text: 'При использовании подарочного сертификата на аукционах Meet for Charity средства в размере необходимой ставки холдируются до окончания аукциона. Списание средств происходит только в случае победы в аукционе. Если ваша ставка не стала выигрышной, средства возвращаются на баланс подарочного сертификата. В случае оплаты товаров и услуг из раздела Charity Shop списание средств происходит сразу в момент покупки.'},
  {id: '5', title: 'Могу ли я доплатить, если сертификат покрывает не всю сумму сделанной ставки или заказа?', text: 'Если ставка в аукционе Meet for Charity или стоимость товаров/услуг в разделе Charity Shop выше номинала подарочного сертификата, остаток средств можно внести банковской картой.'},
  {id: '6', title: 'Могу ли я использовать сертификат в нескольких аукционах одновременно?', text: 'В случае участия в аукционе средства в размере необходимой ставки холдируются до его окончания. Остаток средств на подарочном сертификате, не участвующий в аукционе, доступнен для участия в других аукционах.'},
  {id: '7', title: 'Что если срок действия сертификата истекает, а я его уже использовал в аукционе?', text: 'Если срок действия сертификата истекает, но вы успели применить его в аукционе, то срок действия продлевается до окончания аукциона. Сертификат будет заблокирован после подведения итогов аукциона.'},
  {id: '8', title: 'Где мне посмотреть срок действия и сколько осталось средств на сертификате?', text: 'После входа в аккаунт на странице https://meetforcharity.today/giftcard/balance вы можете ввести номер сертификата и его пин-код и проверить основные данные: номинал, текущий баланс, сколько средств захолдировано и сколько уже использовано.'}]

  const paymentStatus = typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('payment')
    : null
  const paymentMessage = paymentStatus === 'success'
    ? 'Оплата прошла успешно. Сертификат отправлен на email, указанный при покупке.'
    : paymentStatus === 'failed'
      ? 'Оплата не прошла. Попробуйте оформить сертификат еще раз.'
      : null

  this.buyRef = null
  const scroll = ()=>{
    if (this && this.buyRef && this.buyRef)
     this.buyRef.scrollIntoView()
  }
  return (
  <div>
    <div className='GiftCards'>
      <div className='Container Container_no-top Container_light Container_orange'>
        {/*<div className="GiftCards__top">
          <div className="GiftCards__text">
            Мы верим, что дарить гораздо приятнее, чем получать. Вы можете подарить своим близким уникальную возможность встретиться с известной персоной
            или приобрести любой товар из раздела Charity Shop.
          </div>
          <div className="GiftCards__text">
            Сертификат Meet For Charity - это подарок, котрый точно запомнится надолго и поможет
            поддержать один из благотворительных Фондов.
          </div>
  </div>*/}

      </div>
      <div className='Container_light GiftCards__bottom'>
        {paymentMessage && (
          <div
            className='GiftCards__text'
            style={{
              backgroundColor: paymentStatus === 'success' ? '#eef9f0' : '#fff3f3',
              border: `1px solid ${paymentStatus === 'success' ? '#cfe5d5' : '#f1c9c9'}`,
              borderRadius: '16px',
              marginBottom: '32px',
              padding: '16px 20px'
            }}
          >
            {paymentMessage}
          </div>
        )}
        <div className="GiftCards__top">
          <div className="GiftCards__top-left">
            <img className='GiftCards__top-img' src={"/assets/img/giftcards/certificate-empty.jpg"}
            alt="" />
          </div>
          <div className="GiftCards__top-right">
            <div className="GiftCards__text">
              Подарочный сертификат Meet For Charity можно оформить только после входа в аккаунт. Это способ подарить близким участие в благотворительных аукционах и поддержать фонды.
            </div>
            <div className="GiftCards__text">
              После оплаты сертификат сразу отправляется на email, указанный при оформлении. Перед покупкой проверьте правила использования сертификата.
            </div>
            <div className="GiftCards__button-wrap">
              {/*<a onClick={this.buyRef && this.buyRef.current && this.buyRef.current.scrollIntoView()} className='Button Button_black'>Купить</a>*/}
              <button type="button" className="Button Button_black"
              onClick={scroll}>Подарить</button>
            </div>
          </div>
        </div>

        <h1 className='Head GiftCards__title'>
          Правильный подарок - <br/> отличный способ помочь!
        </h1>
        <div className="GiftCards__icons">
          <div className="GiftCards__icons-item">
            <img className='GiftCards__icons-image1' src="/assets/img/giftcards/icon1.png" alt="icon_email"/>
            <div className="GiftCards__icons-text">Покупка сертификата доступна только после входа в аккаунт</div>
          </div>
          <div className="GiftCards__icons-item">
            <img className='GiftCards__icons-image1' src="/assets/img/giftcards/icon2.png" alt="icon_world"/>
            <div className="GiftCards__icons-text">Сертификат можно использовать в аукционах Meet For Charity и в разделе Charity Shop</div>
          </div>
          <div className="GiftCards__icons-item">
            <img className='GiftCards__icons-image1' src="/assets/img/giftcards/icon3.png" alt="icon_card"/>
            <div className="GiftCards__icons-text">Любой номинал <br/>от 3&nbsp;000 до 500&nbsp;000 руб</div>
          </div>
          <div className="GiftCards__icons-item">
            <img className='GiftCards__icons-image1' src="/assets/img/giftcards/icon4.png" alt="icon_365"/>
            <div className="GiftCards__icons-text">После оплаты сертификат сразу отправляется на email, указанный при оформлении. Срок действия - 1 год</div>
          </div>
        </div>

        <h1 className='Head GiftCards__title' ref={instance => this.buyRef = instance}>
          Подарить
        </h1>
        <GiftCardsBuy />

        <div className='GiftCards__check'>
          {/*<h1 className='Head GiftCards__title' onClick={()=>setShowCheckCard(!showCheckCard)}>
            Проверка баланса
          </h1>*/}
          <CheckCardForm from='main'/>
        </div>

        <div className='GiftCards__faq'>
          <h1 className='Head GiftCards__title'>
            FAQ
          </h1>
          {questionsArr.map(el => (
            <div className="GiftCards__question" key={el.id}>
              <Hide title={el.title} text={el.text} labelClass="GiftCards__question-label" textClass="GiftCards__question-text"/>
            </div>)
          )}
        </div>

        <div className='GiftCards__feedback'>
          <div className='GiftCards__feedback-text'>
            Если вы не нашли ответ на интересующий вопрос, напишите нам
          </div>
          <Textarea className='GiftCards__feedback-textarea' value={tmpData.message} onChange={setData('message')} minRows={4} placeholder='' />
          {/* <div className="GiftCards__text-sm">Служба поддержки: support@meetforcharity.today</div> */}
          <button className='Button Button_black' onClick={submit}><FormattedMessage id='profile_report.send' /></button>

          {<Loader isLight />}
          {!isNil(success) && <div className='Text'> <FormattedMessage id='contacts_form.error' /> </div>}
        </div>
        <div className="GiftCards__pdf">
          <a className="GiftCards__pdf-item" href="/giftcards/rules">
            <button type="button" className="GiftCards__pdf-button"><FileLogo /></button>
            <div className="GiftCards__pdf-text">Полные правила пользования сертификатом</div>
          </a>
        </div>


      </div>
    </div>

    <Overlay isActive={success} onClose={e => setSuccess(null)}>
      <div className='Contacts-form__title Head'>
        <FormattedMessage id='contacts_form.message_sent' />
      </div>
    </Overlay>
    {/*<Overlay isActive={formOpened} onClose={e => setFormState(false)}>
      <Form />
    </Overlay>*/}
  </div>
) }

const mapStateToProps = state => ({
  ...state.contacts,
  ...state.feedback,
  currentLocale: state.intl.locale,
  user: getLoggedUser(state),
})

const mapDispatchToProps = dispatch => bindActionCreators({ getFeedback, sendFeedback }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withState('formOpened', 'setFormState', false),
  withState('tmpData', 'setTmpData', {}),
  withState('success', 'setSuccess', null),
  withState('showCheckCard', 'setShowCheckCard', false),
  fetchingState({ multi: true }),
  withHandlers({
    get: ({ getFeedback, fetchingWrap }) => () => fetchingWrap(getFeedback.bind(this), 'info'),
    setData: ({ setTmpData, tmpData }) => field => e => {
      tmpData[field] = e.target.value
      setTmpData(tmpData)
    },
    clearData: ({ setData, setTmpData }) => () => {
      setTmpData({})
    },
    submit: ({ sendFeedback, info, tmpData, setSuccess, fetchingWrap }) => async e => {
      e && e.preventDefault()
      if (tmpData.message){
        setSuccess(null)
        const data = { ...info, ...tmpData, topic: 'giftcards' }
        if (!data.name) data.name = 'Пользователь'
        if (!data.contact) data.contact = 'Страница подарочных карт'
        const result = await fetchingWrap(sendFeedback.bind(this, data), 'send')
        setSuccess(result === 200)
      }
    }
  }),
  withProps(props => ({
    tmpData: { ...props.info, ...props.tmpData }
  })),
  lifecycle({
    componentWillMount () {
      this.props.clearData()
      this.props.setTmpData({})
      this.props.get()
    },
    componentWillUnmount () {
      this.props.setTmpData({})
      this.props.setSuccess(null)
      this.props.clearData()
    }
  })
)(GiftCardsPage)



// WEBPACK FOOTER //
// ./src/containers/GiftCards.jsx